// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "resource/css/" + (chunkId === 750 ? "[request]" : chunkId) + "." + {"10":"aae60d3a","750":"868076a5"}[chunkId] + ".css";
};